import { handleActions } from 'redux-actions';
import { setPassengers } from './actions';
const initialState = [];
const passengersReducer = handleActions({
    [setPassengers.toString()]: (_, { payload }) => payload
}, initialState);
export default passengersReducer;
